import { Button, Card, Col, Row } from 'react-bootstrap';
import { ReviewFormat } from '../../../graphql/__generated__/graphql';
import React from 'react';

interface Props {
    onSelect: (reviewFormat: ReviewFormat) => void;
}

const reviewFormats = [
    {
        name: 'Algorithm',
        description: 'Assign numerical values to each criterion',
        value: ReviewFormat.Algorithm,
    },
    {
        name: 'Descriptive',
        description: 'Written feedback for each criterion',
        value: ReviewFormat.Descriptive,
    },
];

const ApplicationReviewFormatSelect: React.FC<Props> = ({ onSelect }) => {
    return (
        <>
            <Row>
                <h1 className="fs-1 fw-bold mb-5">Evaluation type</h1>
            </Row>
            <Row>
                <h2>Select the type of evaluation you would like to complete</h2>
            </Row>
            <Row>
                {reviewFormats.map((reviewFormat) => (
                    <Col xs={3} key={reviewFormat.name}>
                        <Card className={'h-100'}>
                            <Card.Header>
                                <Card.Title>{reviewFormat.name}</Card.Title>
                            </Card.Header>
                            <Card.Body>{reviewFormat.description}</Card.Body>
                            <Card.Footer>
                                <Button
                                    variant={'secondary'}
                                    onClick={() => onSelect(reviewFormat.value)}
                                >
                                    Select {reviewFormat.name.toLowerCase()}
                                </Button>
                            </Card.Footer>
                        </Card>
                    </Col>
                ))}
            </Row>
        </>
    );
};

export default ApplicationReviewFormatSelect;
